module.exports = "<div class=\"ivu-col ivu-col-span-17\">\r\n    start works!          \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/start/start.component.html
// module id = ./src/app/view/start/start.component.html
// module chunks = start.module